import { createContext } from 'react';

import type { PageContextType } from './shared/types';

export default createContext<PageContextType>(null);
